import React, { useState } from 'react';

import { Formik } from 'formik';
import SiteForm from './SiteForm'
import { validationSiteForm } from '../../../utils/validations';

import './addSite.scss'

import { addSite } from '../../../store/actions/UserAction'
import { connect } from 'react-redux';

/* Toaste o Notification */
import Snackbar from '../../../components/Snackbar';
import { isMobile } from 'react-device-detect';
import Scroll from 'react-scroll';
import { showLoading, hideLoading } from "../../../store/actions/LoadingActions";
import TrophieModal from '../../Modal/TrophieModal';

function AddSite(props) {

  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success'
  });
  //const [ openTrophieModal, setOpenTrophieModal ] = useState(false);

  const { evento, sede, arrSedeAll, showLoading, hideLoading, trophie, authClient, handleOpenTrophieModal  } = props;

  var scroller = Scroll.scroller;
  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success'
    });
  };

  /* const handleOpenTrophieModal = () => {
    setOpenTrophieModal(true);
  };

  const handleCloseTrophieModal = () => {
    setOpenTrophieModal(false);
  }; */

  const resetTab = () => {
    evento(false)
    
  }

  const handleSubmit = (values, { setSubmitting, setFieldError, resetForm }) => {

    const arrayValues = Object.values(values)
    let boolValues = arrayValues.every(elem => elem);

    setSubmitting(false);
    showLoading()
    
    props.addSite(props.uid, values, sede, boolValues)
      .then(res => {
        
        hideLoading()
        setTimeout(() => {
          resetForm()
          resetTab(); 
          scroller.scrollTo('sitesForm', { smooth: true, offset: -64 });
        }, 2000)

        if (trophie) {
          setFeedbackMessage({
            open: true,
            message: 'Tus cambios se han guardado con éxito',
            variant: 'success'
          });
          
        } else {
          handleOpenTrophieModal();
        }

      }).catch(error => {})
  };


  const formValues = {
    direccion: '',
    estado: '',
    municipio: '',
  };

  


  return (
    <>

      {/* ------------------------------- */}

      <div className="addSite" >

        <Formik
          initialValues={formValues}
          validationSchema={validationSiteForm}
          onSubmit={handleSubmit}
          render={props => (<SiteForm evento={resetTab} {...props} />)}
        />

      </div>
      
      <Snackbar
          open={feedbackMessage.open}
          message={feedbackMessage.message}
          variant={feedbackMessage.variant}
          handleClose={handleCloseFeedbackMessage}
          vertical="top"
          horizontal="right"
          snackbarTop={isMobile ? '70px' : '80px'}
        />
      
      {/* <TrophieModal
        open={openTrophieModal}
        trophieValidation={trophie}
        topic="award-profile"
        handleClose={handleCloseTrophieModal}
        title={authClient.role === 'lawFirm' ?
          'Sedes' :
          'Sede'
        }
        subtitle={['¡Felicidades', <br />, 'haz obtenido este logro!']}
        footer='Agregar la ubicación de tu centro de trabajo es 
        importante para que los clientes te reconozcan'
      /> */}
    </>
  )
}




const mapStateToProps = state => ({
  /*  formValues: state.formValues, */
  authClient: state.authClient,
  uid: state.authClient.uid,
  trophie: state.authClient.awardPerfil.site,
  sede: state.authClient.sede,
});

const mapDispatchToProps = dispatch => ({
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
  addSite: (uid, values, sede, boolValues) => dispatch(addSite(uid, values, sede, boolValues))
});

export default connect(mapStateToProps, mapDispatchToProps)(AddSite);
